export const CONTENT = 'content';
export const FOOTER = 'footer';
export const HEADER = 'header';
export const LINKS = 'links';
export const MEDIA = 'media';
export const STICKER = 'sticker';
export const ELEMENT_TYPES = {
    CONTENT,
    FOOTER,
    HEADER,
    LINKS,
    MEDIA,
    STICKER,
};
//# sourceMappingURL=ElementTypes.js.map